/**
 * Joins class names, dropping anything absent.
 *
 * Two reasons this exists rather than template literals:
 *
 * 1. A CSS module's members are typed through an index signature, so with
 *    `noUncheckedIndexedAccess` every `styles.foo` is `string | undefined`. A
 *    template literal would happily interpolate that as the text "undefined";
 *    props typed as strictly `string` reject it outright.
 * 2. Conditional classes read better as arguments than as nested ternaries inside
 *    a template.
 */
/**
 * Falsy values of any type are accepted and dropped. That is what makes
 * `cx(styles.a, condition && styles.b)` work when `condition` is a ReactNode or a
 * count rather than a boolean — narrowing it at every call site would be noise.
 * Only strings survive the filter, so a stray number cannot become a class name.
 */
export const cx = (
  ...classes: Array<string | number | bigint | boolean | null | undefined>
): string => classes.filter((entry): entry is string => typeof entry === 'string' && entry !== '').join(' ');
